import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Select,
  Form,
  Button,
  Space,
  Tooltip,
  Menu,
  Checkbox,
  Input,
  Dropdown,
  Table,
  Modal,
} from "antd";

import { getRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { t } from "i18next";

import { authUserData } from "../../utils/Helper";

import SearchIcon from "../../image/SearchIcon.svg";

import {
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
// import { useTranslation } from "react-i18next";

import { ErrorNotificationMsg } from "../../utils/Notifications";
import { debounce } from "lodash";

import AddMoneyModelAdmin from "./AddMoneyModelAdmin";
import CreditMoneyModelAdmin from "./CreditMoneyModelAdmin";
import AdjustmentMoneyModelAdmin from "./AdjustmentMoneyModelAdmin";

function WalletAdminPostpaid() {
  const { Option } = Select;

  const [reload, setReload] = useState(false);
  // const { t } = useTranslation();
  const [form] = Form.useForm();
  const [driverForm] = Form.useForm();

  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);

  const [companyList, setCompanyList] = useState([]);
  const [companyId, setCompanyId] = useState(null);

  const [walletId, setWalletId] = useState(null);
  const [modalKey, setModalKey] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenCredit, setIsModalOpenCredit] = useState(false);
  const [isModalOpenAdjustment, setIsModalOpenAdjustment] = useState(false);
  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  const intialFilter = {
    company_type: "",
    company: "",
  };

  const [loading, setLoading] = useState(false);
  const [stateFilter, setStateFilter] = useState(intialFilter);

  const formRef = useRef();

  const getCompanyName = async () => {
    try {
      // setapiLoading(true);
      const response = await getRequest("company/?no_pagination=true");

      const { data } = response.data;
      setCompanyList(data);
      formRef.current.setFieldsValue(response.data.data);
      // setapiLoading(false);
    } catch (error) {
      // setapiLoading(false);
    }
  };

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  const getWalletList = async () => {
    setLoading(true);

    try {
      let apiResponse = await getRequest(
        `wallet/?company_id=${
          stateFilter?.company
        }&company_type=${"Post Paid"}`,
        state
      );

      if (apiResponse?.data?.results?.success) {
        setEmployeeList(apiResponse?.data?.results?.data);
        settotalCount(apiResponse.data.count);
        setLoading(false);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching wallet list"));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getWalletList();
  }, [state, t, reload]);

  useEffect(() => {
    getCompanyName();
  }, []);
  const [checkedList, setCheckedList] = useState([
    "credit_due",
    "balance",
    "company_type",
    "company",
    "operation",
  ]);

  const [columns, setColumns] = useState([]);

  const allColumns = [
    { key: "company", title: "Company" },
    { key: "company_type", title: "Company Type" },
    // { key: "balance", title: "Wallet Balance" },
    { key: "credit_due", title: "Credit Due" },
    { key: "operation", title: "Action" },
  ];
  useEffect(() => {
    const updatedColumns = [
      {
        title: "Company",
        dataIndex: "company_name",
        key: "company",
        // width: 50,
        sorter: true,
      },
      {
        title: "Company Type",
        dataIndex: "company_type",
        key: "company_type",
        sorter: true,
        // width: 50,
      },

      //   {
      //     title: "Wallet Balance",
      //     dataIndex: "balance",
      //     key: "balance",
      //     sorter: true,
      //     // width: 50,
      //   },

      {
        title: "Credit Due",
        dataIndex: "credit_due",
        key: "credit_due",
        sorter: true,
        render: (credit_due) => `$${credit_due}`,
        // width: 50,
      },

      {
        title: "Action",
        key: "operation",
        sorter: true,
        fixed: "right",
        width: 80,
        render: (text, record) => (
          <Space>
            {/* {record?.company_type === "Pre Paid" && (
              <Tooltip
                color={colors}
                placement="left"
                title={<span style={{ color: "#fff" }}>Recharge Wallet</span>}
              >
                <span
                  className="material-symbols-outlined"
                  onClick={() => handleAddMoney(record.id)}
                  style={{ cursor: "pointer" }}
                >
                  add
                </span>
              </Tooltip>
            )} */}

            {record?.company_type === "Post Paid" &&
              record?.credit_due !== "0.00" && (
                <Tooltip
                  color={colors}
                  placement="left"
                  title={<span style={{ color: "#fff" }}>Record Payment</span>}
                >
                  <span
                    className="material-symbols-outlined"
                    onClick={() => handleCreditMoney(record.id, record.company)}
                    style={{ cursor: "pointer" }}
                  >
                    mintmark
                  </span>
                </Tooltip>
              )}
            {/* <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Wallet Adjustment</span>}
            >
              <span
                className="material-symbols-outlined"
                onClick={() => handleAdjustmentMoney(record.id, record.company)}
                style={{ cursor: "pointer" }}
              >
                request_quote
              </span>
            </Tooltip> */}
          </Space>
        ),
      },
    ].filter((column) => checkedList.includes(column.key));
    setColumns(updatedColumns);
  }, [checkedList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleCompanyFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company: value,
    }));
  };

  // const handleAddMoney = (id) => {
  //   setModalKey((prevKey) => !prevKey);
  //   setWalletId(id);
  //   showModal();
  // };
  const handleCreditMoney = (id, company) => {
    // setModalKey((prevKey) => !prevKey);
    setModalKey(Date.now());
    setWalletId(id);
    setCompanyId(company);
    showModalCredit();
  };
  // const handleAdjustmentMoney = (id, company) => {
  //   setModalKey((prevKey) => !prevKey);
  //   setWalletId(id);
  //   showModalAdjustment();
  //   setCompanyId(company);
  // };
  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const showModalCredit = () => {
    setIsModalOpenCredit(true);
  };
  const handleOkCredit = () => {
    setIsModalOpenCredit(false);
  };
  const handleCancelCredit = () => {
    setIsModalOpenCredit(false);
  };
  // const showModalAdjustment = () => {
  //   setIsModalOpenAdjustment(true);
  // };
  const handleOkAdjustment = () => {
    setIsModalOpenAdjustment(false);
  };
  const handleCancelAdjustment = () => {
    setIsModalOpenAdjustment(false);
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields();
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (sortField === "company_type" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_type";
    }
    if (sortField === "company_type" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_type";
    }
    if (sortField === "balance" && sortOrder === "ascend") {
      sortingEnumKey = "balance";
    }
    if (sortField === "balance" && sortOrder === "descend") {
      sortingEnumKey = "-balance";
    }

    if (sortField === "credit_due" && sortOrder === "ascend") {
      sortingEnumKey = "credit_due";
    }
    if (sortField === "credit_due" && sortOrder === "descend") {
      sortingEnumKey = "-credit_due";
    }

    return sortingEnumKey;
  };

  const handleResetGrid = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };
  const handleApplyFilter = async () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };

  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });

    formRef.current.setFieldsValue({
      // Set to undefined to keep placeholder

      company_type: undefined,
      company: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const colors = ["#737373"];
  return (
    <>
      <div className="layout-content">
        <Row gutter={[24, 0]}>
          {/* Wallet list */}
          <Col xs={24} className="mb-24">
            {authUserData()?.permission.includes("package|view_route") && (
              <section className="grid-sec">
                <div className="ListingTopBar">
                  <div className="pagenamewrap">
                    <div className="pagename">
                      <h3>{t("Post Paid Wallet Management")}</h3>
                    </div>
                    <Space>
                      <div className="searchwrp">
                        <Space direction="vertical">
                          <Form form={form}>
                            <Form.Item name="search" initialValue="">
                              <Search
                                prefix={
                                  <img
                                    src={SearchIcon}
                                    alt="SearchIcon"
                                    className="SearchIcon"
                                    width={22}
                                  />
                                }
                                placeholder={t("pl_search_list")}
                                onChange={searchCallbackDelayed}
                              />
                            </Form.Item>
                          </Form>
                        </Space>
                      </div>
                      {state?.search ? (
                        <Button
                          className="BlueShadowBtn"
                          type="primary"
                          htmlType="button"
                          onClick={() => handleResetGrid()}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <UndoOutlined
                              style={{ fontSize: "16px", color: "#fff" }}
                            />{" "}
                            Reset
                          </span>
                        </Button>
                      ) : (
                        // </Tooltip>
                        ""
                      )}

                      <div className="gridiconswrap">
                        <Dropdown
                          overlay={columnMenu}
                          trigger={["click"]}
                          placement="bottomRight"
                          visible={dropdownVisible}
                          onVisibleChange={(visible) =>
                            setDropdownVisible(visible)
                          }
                        >
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<InsertRowLeftOutlined />}
                            onClick={() => setDropdownVisible(!dropdownVisible)}
                          />
                        </Dropdown>
                      </div>
                    </Space>
                  </div>
                </div>

                <div className="Package-body">
                  <div className="filterrow packagefilter">
                    <div className="filtercol">
                      <Form autoComplete="off" ref={formRef}>
                        <Row wrap>
                          <Col
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            className="TextFeild gutter-row"
                          >
                            <Form.Item name="company" label={t("pl_company")}>
                              <Select
                                placeholder={t("val_company")}
                                showArrow
                                showSearch
                                // allowClear
                                style={{ width: "170px" }}
                                // value={state.country}
                                name="company"
                                optionFilterProp="children"
                                onChange={(value) => handleCompanyFilter(value)}
                              >
                                {companyList?.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.company_name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* <Col
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            className="TextFeild gutter-row"
                          >
                            <Form.Item
                              name="company_type"
                              label={t("Type")}
                              value={state?.type}
                            >
                              <Select
                                showArrow
                                placeholder={t("Select Type")}
                                onChange={(value) =>
                                  handleResidentSelectChange(value)
                                }
                              >
                                <Option key="Pre Paid" value="Pre Paid">
                                  Pre Paid
                                </Option>
                                <Option key="Post Paid" value="Post Paid">
                                  Post Paid
                                </Option>
                              </Select>
                            </Form.Item>
                          </Col> */}
                        </Row>
                      </Form>
                    </div>
                    <div className="btnscol btncolpack">
                      <Space className="btnpack">
                        <>
                          {/* <Tooltip title="Apply Filter"> */}
                          <span>
                            <ButtonField
                              className="SaveGradiantBtn"
                              type="primary"
                              htmlType="Apply"
                              label={
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <FilterOutlined
                                    style={{ fontSize: "16px" }}
                                  />{" "}
                                  Apply Filter
                                </span>
                              }
                              onClick={handleApplyFilter}
                            />
                          </span>
                          {/* </Tooltip> */}
                          {stateFilter?.company || stateFilter?.company_type ? (
                            // <Tooltip title="Reset Filter">
                            <span>
                              <ButtonField
                                className="SaveGradiantBtn"
                                type="primary"
                                htmlType="Reset"
                                label={
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    <UndoOutlined
                                      style={{
                                        fontSize: "16px",
                                        color: "#fff",
                                      }}
                                    />{" "}
                                    Reset
                                  </span>
                                }
                                onClick={handleResetFilter}
                              />
                            </span>
                          ) : (
                            // </Tooltip>
                            ""
                          )}
                        </>
                        {/* ) : (
                  ""
                )} */}
                      </Space>
                    </div>
                  </div>
                  {authUserData()?.permission.includes(
                    "package|view_route"
                  ) && (
                    <Table
                      //   scroll={{
                      //     x: 3000,
                      //   }}
                      // rowSelection={rowSelection}
                      rowKey={(record) => record.id}
                      columns={columns.filter((col) => !col.hidden)}
                      dataSource={employeeList}
                      loading={loading}
                      pagination={{
                        defaultCurrent: state.page,
                        defaultPageSize: state.pagesize,
                        total: totalCount,
                        showTotal: (total) => `Total ${total} items`,
                        showSizeChanger: true,
                        locale: {
                          items_per_page: "Items / Page",
                        },
                      }}
                      onChange={handleTableChange}
                    />
                  )}
                </div>
              </section>
            )}
          </Col>
        </Row>
        {/* <TransactionListAdmin /> */}
        <Modal
          className="ModelPopupSec"
          title={t("Add Wallet Recharge")}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          closable={false}
          wrapClassName="modal-wrapper"
          keyboard={false}
        >
          <AddMoneyModelAdmin
            handleCancel={handleCancel}
            setReload={setReload}
            walletId={walletId}
            modalKey={modalKey}
            setStateM={setState}
          />
        </Modal>

        <Modal
          className="ModelPopupSecInvoice"
          centered
          title={t("Record Payment (Post Paid)")}
          open={isModalOpenCredit}
          onOk={handleOkCredit}
          onCancel={handleCancelCredit}
          closable={false}
          wrapClassName="modal-wrapper"
          style={{ width: "max-content" }}
          keyboard={false}
          width={1000}
        >
          <CreditMoneyModelAdmin
            handleCancel={handleCancelCredit}
            setReload={setReload}
            walletId={walletId}
            companyId={companyId}
            modalKey={modalKey}
            setStateM={setState}
          />
        </Modal>
        <Modal
          className="ModelPopupSecAddRecharge"
          centered
          title={t("Wallet Adjustment")}
          open={isModalOpenAdjustment}
          onOk={handleOkAdjustment}
          onCancel={handleCancelAdjustment}
          closable={false}
          wrapClassName="modal-wrapper"
          keyboard={false}
          width={1000}
        >
          <AdjustmentMoneyModelAdmin
            handleCancel={handleCancelAdjustment}
            setReload={setReload}
            walletId={walletId}
            companyId={companyId}
            modalKey={modalKey}
            setStateM={setState}
          />
        </Modal>
      </div>
    </>
  );
}

export default WalletAdminPostpaid;
